import { Component, OnInit, OnChanges, SimpleChanges, Input } from '@angular/core';
import { Inject, NgModule } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// patrones de enrutamiento interno
import { ActivatedRoute, Router } from '@angular/router';
// par ausar formularios contiene formGroup y formcontrol
import { FormGroup, FormControl, FormArray, Validators} from '@angular/forms';
// Modelos
import { Visita } from '../../models/visita';
// Servicios
import { VisitasService } from '../../services/visitas.service';


import { SelectMapDirectionComponent } from './select-map-direction/select-map-direction.component';
import { Direccion } from '../../models/direccion';

import { Observable, } from 'rxjs';
import { map } from 'rxjs/operators';
import * as moment from 'moment';

import { AgFileUploadComponent } from '../ag-file-upload/ag-file-upload.component';
import { FileBrowserComponent } from '../file-browser/file-browser.component';
import { AuthService } from '../../services/auth.service';
import { TasacionArchivo} from '../../models/TasacionArchivo';
import { TasacionesService } from '../../services/tasaciones.service';
import { TasacionArchivoValues } from '../../models/enums';
import * as jQuery from 'jquery';
import { GlobalUIUtilsService } from '../../services/global-ui-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorHelper } from '../../models/ErrorHelper';
import { TasacionModel } from '../../models/TasacionModel';

@Component({
  selector: 'app-visitas-edit',
  templateUrl: './visitas-edit.component.html',
  styleUrls: ['./visitas-edit.component.scss']
})
export class VisitasEditComponent implements OnInit, OnChanges {

  step: string;
  selectMap: boolean;
  // the view title
  title: string;
  // the form model
  form: FormGroup;

  public visita: Visita;
  public tasacion: TasacionModel;
  public codTasacion: string;

  @Input() id: number;
  @Input() version: number;
  //@Input() estancia: number;
  //id?: number;
  //version?: number;
  estancia?: number;

  // Parametros para el cambio de ventana
  eventSwipe = '';
  stepVal: number;
  maxstep = 7;
  minstep = 1;

  //Selects de los formularios
  tipoInmueble: Map<string, string>;
  selectOcupacion: Map<string, string>;
  selectTerraza: Map<string, string>;
  selectCalefaccion: Map<string, string>;
  selectGaraje: Map<string, string>;

  nav_visible: boolean;

  //Lista de ficheros de la visita
  ficherosVisitaList: Observable<TasacionArchivo[]>;
  ficherosTasacion: Observable<TasacionArchivo[]>;
  //Esta variable se usa para indicar que ha habido una actualziacion
  //de los ficheros que se han subido que necesita refrescarse la informacion.
  needRefreshArchivos = false;
  //Titulo de la zona de imagenes
  Titulo = 'Fotos';
  message = this.translate.instant('comunes.toastr_guardado');

  //Constructor
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    @Inject('BASE_URL')
    private baseUrl: string,
    public _authService: AuthService,
    public _TasacionesService: TasacionesService,
    private visitaService: VisitasService,
    private _GlobalUIUtilsService: GlobalUIUtilsService,
    private translate: TranslateService  ) { }

  //Funcion que se llama al iniciar el componente
  ngOnInit() {
    //El mapa sale como no visible
    this.selectMap = false;
    this.establecerStep();
    this.cargarSelect();
    this.createForm();
    this.loadData();
    this.nav_visible = true;
  }

  createForm()
  {
    //Creamos el formulario
    this.form = new FormGroup({
      fechaVisita: new FormControl(''),
      calle: new FormControl(''),
      numero: new FormControl(''),
      bloque: new FormControl(''),
      altura: new FormControl(''),
      letra: new FormControl(''),
      idTipoInmueble: new FormControl(''),
      tipoInmueble: new FormControl(''),
      ocupacionInmueble: new FormControl(''),
      superficieUtil: new FormControl(''),
      superficieAdoptada: new FormControl(''),
      superficieCatastral: new FormControl(''),
      superficieConstruida: new FormControl(''),
      tieneTerrza: new FormControl(''),
      superficieUtilTerraza: new FormControl(''),
      tipoTerraza: new FormControl(''),
      tieneCalefaccion: new FormControl(''),
      tipoCalefaccion: new FormControl(''),
      tieneAireAcondicionado: new FormControl(''),
      numEstanciasAireAcond: new FormControl(''),
      tieneTrastero: new FormControl(false),
      superficieUtilTrastero: new FormControl(''),
      tieneGaraje: new FormControl(false),
      tipoGaraje: new FormControl('')
    });
  }

  //Se estable el step de la ruta si no tiene ningun se va al paso 1
  private establecerStep()
  {
    this.step = this.activatedRoute.snapshot.paramMap.get('step');
    if (this.step === undefined || this.step === null || !this.step.includes('step'))
    {
      this.step = 'step1';
    }
  }

  //Cargamos de la base de datos las diferentes opciones de los select
  private cargarSelect()
  {
    this.visitaService.getTiposInmueble().subscribe((res: Map<string, string>) => this.tipoInmueble = res);
    this.visitaService.getSelectOcupacion().subscribe((res: Map<string, string>) => this.selectOcupacion = res);
    this.visitaService.getTipoTerraza().subscribe((res: Map<string, string>) => this.selectTerraza = res);
    this.visitaService.getTipoCalefaccion().subscribe((res: Map<string, string>) => this.selectCalefaccion = res);
    this.visitaService.getTipoGaraje().subscribe((res: Map<string, string>) => this.selectGaraje = res);
  }


  ngOnChanges(changes: SimpleChanges): void
  {
    this.comprobarChecks();
  }

  //Esta funcion se llama al cambiar el valor de un impur que guarda y comprueba los checks
  changeInput()
  {
    console.log('Guardando...');
    this.save();
    this.comprobarChecks();
  }

  //Esta funcion es la encargada de habiliar o desabilitar diferentes opciones de la visita
  //dependiendo de los checks seleccionados.
  comprobarChecks()
  {
    //Si la terraza esta activa puedes estableces la superficie y su tipo
    if (this.visita.tieneTerrza === false)
    {
      this.form.get('superficieUtilTerraza').disable();
      this.form.get('tipoTerraza').disable();
    }
    else
    {
      this.form.get('superficieUtilTerraza').enable();
      this.form.get('tipoTerraza').enable();
    }

    //Si se ha amrcado que tiene calefaccion se puede asignar el tipo
    if (this.visita.tieneCalefaccion === false)
      this.form.get('tipoCalefaccion').disable();
    else
      this.form.get('tipoCalefaccion').enable();

    //Si se ha marcado que tiene Aire acondicionado se puede asignar el numero de estnacias que lo tiene
    if (this.visita.tieneAireAcondicionado === false)
      this.form.get('numEstanciasAireAcond').disable();
    else
      this.form.get('numEstanciasAireAcond').enable();

    //Si se marca que tiene trastero se puede marcar las superficie util
    if (this.form.get('tieneTrastero').value === false)
      this.form.get('superficieUtilTrastero').disable();
    else
      this.form.get('superficieUtilTrastero').enable();

    //Si se le marca que tiene garaje se le puede amrcar el tipo
    if (this.form.get('tieneGaraje').value === false)
      this.form.get('tipoGaraje').disable();
    else
      this.form.get('tipoGaraje').enable();
  }

  //Esta funcion se encarga de cargas los datos de la visita
  private async loadData() {

    // retrieve the ID from the 'id' parameter
    this.cargarVariablesUrl();

    try {
      if (this.id && this.version)
      {
        this.visita = await this.visitaService.get(this.id, this.version).toPromise();
        this.tasacion = await this._TasacionesService.getTasacionID(this.visita.idTasacion).toPromise();
        this.codTasacion = this.tasacion.codigoTasacion;

        this.title = 'Editar';
        this.form.patchValue(this.visita);
        this.comprobarChecks();
        this.needRefreshArchivos = true;
        this.refreshArchivos();
      }
    }
    catch (err) {
      console.error(err);
    }

  }

  //Se encarga de recoger las variables de la URL
  private cargarVariablesUrl()
  {
    this.id = +this.activatedRoute.snapshot.paramMap.get('id');
    this.version = +this.activatedRoute.snapshot.paramMap.get('version');
    if (this.activatedRoute.snapshot.paramMap.keys.includes('idEstancia'))
      this.estancia = +this.activatedRoute.snapshot.paramMap.get('idEstancia');
    //Si estubieramos en la edicion de una estancia
    if (this.estancia != null && this.estancia !== undefined && this.step !== undefined && this.step === 'step6')
      this.step += 'Estancia';
  }

  //Esta funcion se encarga de guardas la visita en la base de datos
  save()
  {
    console.log(this.form)
    const visita = (this.id && this.version) ? this.visita : null;
    if(visita)
    {
      visita.fechaVisita = moment(this.form.get('fechaVisita').value).toDate();
      visita.calle = this.form.get('calle').value;
      visita.numero = this.form.get('numero').value;
      visita.bloque = this.form.get('bloque').value;
      visita.altura = this.form.get('altura').value;
      visita.letra = this.form.get('letra').value;
      visita.idTipoInmueble = this.form.get('idTipoInmueble').value;
      visita.ocupacionInmueble = +this.form.get('ocupacionInmueble').value;
      visita.superficieUtil = this.form.get('superficieUtil').value;
      visita.superficieCatastral = this.form.get('superficieCatastral').value;
      visita.superficieConstruida = this.form.get('superficieConstruida').value;
      visita.superficieAdoptada = this.form.get('superficieAdoptada').value;
      visita.tieneTerrza = this.form.get('tieneTerrza').value;
      visita.superficieUtilTerraza = this.form.get('superficieUtilTerraza').value;
      visita.tipoTerraza = +this.form.get('tipoTerraza').value;
      visita.tieneCalefaccion = this.form.get('tieneCalefaccion').value;
      visita.tipoCalefaccion = +this.form.get('tipoCalefaccion').value;
      visita.tieneAireAcondicionado = this.form.get('tieneAireAcondicionado').value;
      visita.numEstanciasAireAcond = this.form.get('numEstanciasAireAcond').value;
      visita.tieneTrastero = this.form.get('tieneTrastero').value;
      visita.superficieUtilTrastero = this.form.get('superficieUtilTrastero').value;
      visita.tieneGaraje = this.form.get('tieneGaraje').value;
      visita.tipoGaraje = +this.form.get('tipoGaraje').value;
      // console.log( JSON.stringify(visita) );
      if (this.id)
      {
        // EDIT mode
        const url = `${this.baseUrl}api/visitas/${this.visita.idTasacion}/${this.visita.version}`;
        this.http
          .put<Visita>(url, visita)
          .subscribe(result => {
            console.log( `Visita ${visita.idTasacion} has been updated.`);
            this._GlobalUIUtilsService.success(this.message);
          }, error => console.log(error));
      }
      else
      {
        console.error('No puedes crear una visitas nueva.');
      }
      console.log('Datos guardados.');
    }

  }

  //Guardar y volver a la lista de visitas
  onSubmit()
  {
    this.save();
    this.router.navigate(['/visitas']);
  }

  //Evento que recoge la direccion del componente nmapa
  getDirection(direccion: Promise<Direccion>)
  {
    direccion.then(value => {
      this.form.patchValue({calle: value.calle});
      this.form.patchValue({numero: value.numero});
      this.save();
    });
  }

  //Boton que muestra el modal de los mapas
  mostrarMaps(isVisible: boolean)
  {
    this.selectMap = isVisible;
  }

  //Evento al hacer swipe en la pantalla, cambia de ventana
  onSwipe(evt)
  {
    const x = Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? 'right' : 'left') : '';
    const y = Math.abs(evt.deltaY) > 40 ? (evt.deltaY > 0 ? 'down' : 'up') : '';

    this.eventSwipe = `${x}${y}`;

    this.stepVal = +this.step.replace('step', '').replace('Estancia', '');
    if (this.eventSwipe === 'right')
    {
      if (this.step.includes('Estancia'))
        this.stepVal = 6;
      else
        this.stepVal--;
    }
    else if (this.eventSwipe  === 'left')
    {
      this.stepVal++;
    }

    if (this.stepVal > this.maxstep ) { this.stepVal = this.maxstep; }
    if (this.stepVal < this.minstep ) { this.stepVal = this.minstep; }

    this.step = `step${this.stepVal}`;
    this.router.navigate([`/visita/${this.id}/${this.version}/${this.step}`]);
  }

  swipeRight()
  {

  }

  swipeLeft()
  {

  }

  //Evento al pulsar una opcion en el nav lateral
  navegar(step)
  {
    this.router.navigate([`visita/${this.id}/${this.version}/${step}`]);
    this.step = step;
    this.closeNav();
    this.nav_visible = true;
  }

  //Boton de finalizar visita
  public async finalziarVisita()
  {
    let resultado = false;

    try {
      await this.visitaService.finalizarVisita(this.visita.idTasacion, this.visita.version).toPromise();
      this.router.navigate(['/visitas']);
    }
    catch (err) {
      console.log(err);
      alert(ErrorHelper.GetClientError(err));

    }


  }

  //Evento cuando se sube un fichero
  onFileUploaded(event)
  {
    this.needRefreshArchivos = true;
    this.refreshArchivos();
  }

  //Evento de eliminar un fichero
  FileDelete(TasacionArchivoID)
  {
    this._TasacionesService.removeArchivoTasacion(TasacionArchivoID).subscribe(data =>
      {
        this.needRefreshArchivos = true;
        this.refreshArchivos();
      }
    );
  }

  //Recarga los archivos de imagenes
  refreshArchivos()
  {
    if (this.needRefreshArchivos)
    {
      if (this.id !== undefined)
      {
        const svcGeneric = this.visitaService.getFicherosVisita(this.visita.idTasacion, this.version, -1);
        this.ficherosVisitaList = svcGeneric.pipe(map( (d) =>
          {
            return d.filter( d2 => d2.tipoArchivo === TasacionArchivoValues.Fotos);
          }
        ));

        this.ficherosTasacion = this._TasacionesService.getArchivosTasacionNoVisita(this.visita.idTasacion);

        this.needRefreshArchivos = false;
      }
    }
  }

  //Abre  el nav lateral con las diferentes ventanas
  openNav() {
    if(this.nav_visible)
    {
      document.getElementById('mySidebar').style.width = '250px';
      document.getElementById('main').style.marginLeft = '250px';
      this.nav_visible = false;
    }
    else
    {
        this.closeNav();
    }
  }

  //Cierra el nav del menu
  closeNav()
  {
    document.getElementById('mySidebar').style.width = '0';
    document.getElementById('main').style.marginLeft = '0';
    this.nav_visible = true;
  }
}
